import React, { useState } from 'react'
import DefaultLayout from '../components/DefaultLayout'
import { Row, Col, Form, Tabs, Input, Button, Select, DatePicker } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { postExpense } from '../redux/actions/expenseAction'
import { useHistory } from 'react-router-dom'
import moment from 'moment';



const { TabPane } = Tabs;

const { Option } = Select;

function PostExpense() {
  const allworkers = useSelector(state => state.workersReducer).workers;
  console.log(allworkers);
  const allsites = useSelector(state => state.sitesReducer).sites;

  const [expenseInfo, setExpenseInfo] = useState({})
  const [activeTab, setActiveTab] = useState("0")
  const dispatch = useDispatch()
  const history = useHistory()

  function onFinalFormFinish(values) {
    setExpenseInfo(values)
    const finalObj = { ...expenseInfo, ...values };
    console.log(finalObj)
    dispatch(postExpense(finalObj));
  }

  return (
    <div>
      <DefaultLayout>
        <Tabs defaultActiveKey='0' activeKey={activeTab}>
          <TabPane tab='Post Expense' key='0'>
            <Form onFinish={onFinalFormFinish} onReset={() => { history.push('/postedExpenses') }}>
              <Row>
                <Col lg={8} sm={24}>
                  <div>
                    <Form.Item name='appliedCandidate' label='Select Employees'>
                      <Select
                        defaultValue={'0'}
                        className="mr-2"
                        style={{ minWidth: 200 }}
                      >
                        <Option value="0" disabled>-- Select Employee --</Option>
                        {allworkers.map(worker => {
                          return <Option value={worker.email} key={worker.fname} >{worker.fname}</Option>
                        })}
                      </Select>
                    </Form.Item>

                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='date' rules={[{ required: true }]} label='Date' initialValue={moment(new Date(), 'dddd, MMMM Do YYYY')}>
                    <DatePicker
                      format='dddd, MMMM Do YYYY'
                      defaultValue={moment(new Date(), 'dddd, MMMM Do YYYY')}
                      style={{ width: 380 }}
                      className="mr-2"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='worksite' rules={[{ required: true }]} label='Worksite' >
                    <Select
                      defaultValue={'0'}
                      className="mr-2"
                      style={{ minWidth: 200 }}
                    >
                      <Option value="0" disabled>-- Select Worksite --</Option>
                      {allsites.map(site => {
                        return <Option value={site.siteName} key={site['_id']} >{site.siteName}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='expense' rules={[{ required: true }]} label='Expense' >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={8} sm={24}>
                  <Form.Item name='type' label='Type' rules={[{ required: true }]} >
                    <Select
                      defaultValue={'0'}
                      className="mr-2"
                      style={{ minWidth: 200 }}
                    >
                      <Option value="0" disabled>-- Select Type --</Option>
                      <Option value="Travel">Travel</Option>
                      <Option value="Lodging">Lodging</Option>
                      <Option value="Food">Food</Option>
                      <Option value="Equipment">Equipment</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>


              <Button htmlType='submit'>Submit</Button>
              <Button htmlType='reset' type="default" danger className="ml-2">Cancel</Button>
            </Form>
          </TabPane>

        </Tabs>
      </DefaultLayout>
    </div>
  )
}

export default PostExpense
